import { render, staticRenderFns } from "./admin_edit_goldFee.vue?vue&type=template&id=92c21cf4&scoped=true"
import script from "./admin_edit_goldFee.vue?vue&type=script&lang=js"
export * from "./admin_edit_goldFee.vue?vue&type=script&lang=js"
import style0 from "./admin_edit_goldFee.vue?vue&type=style&index=0&id=92c21cf4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c21cf4",
  null
  
)

export default component.exports